
/**
 * 重新封装 element message
 */

import { Message } from 'element-ui'
 interface BaseMessage{
    type? : string,
    message? : string,
}

const defaultSuccess = {
  type: 'success',
  message: '操作成功'
}
const defaultInfo = {
  type: 'info',
  message: '已取消操作'
}
const defaultWarning = {
  type: 'warning',
  message: '操作不正确,请重试'
}
const defaultError = {
  type: 'warning',
  message: '操作不正确,请重试'
}

export const NBMessageSuccess = (_that: any, { type, message }:BaseMessage = defaultSuccess) => _that.$message({
  type: 'success',
  message: message
})
export const NBMessageInfo = (_that: any, { type, message }:BaseMessage = defaultInfo) => _that.$message({
  type: 'info',
  message: message
})
export const NBMessageWarning = (_that: any, { type, message }:BaseMessage = defaultWarning) => _that.$message({
  type: 'warning',
  message: message
})
export const NBMessageError = (_that: any, { type, message }:BaseMessage = defaultError) => _that.$message({
  type: 'error',
  message: message
})
